import { cn } from "@/lib/utils";

/** Static loading placeholder. No pulse: continuous animations are avoided app-wide. */
function Skeleton({ className, ...props }: React.ComponentProps<"div">) {
  return (
    <div
      data-slot="skeleton"
      aria-hidden="true"
      className={cn("bg-muted rounded-md", className)}
      {...props}
    />
  );
}

/**
 * Placeholder for one line of text. Sized in line-height units, so it takes exactly the
 * height the loaded line will take in the surrounding text style.
 */
function TextLineSkeleton({ className }: { className?: string }) {
  return <Skeleton className={cn("my-[0.2lh] h-[0.6lh]", className)} />;
}

export { Skeleton, TextLineSkeleton };
